// extracted by mini-css-extract-plugin
export default {"layoutContainer":"LayoutContainer_layoutContainer__2D6Gi"};